import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';

import PaymentButton from 'Components/Payment/PaymentButton';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';
import PaymentContext from 'Components/Payment/payment-context';

export default function WalletPayment({ method }) {
  const { currency, isSubscription, isNewSavedMethod } = useContext(PaymentContext);
  const transactionFee = get(method, 'configuration.transactionFee');
  const oneClickOption = get(method, 'configuration.oneClickOption');

  const [enableOneClick, setEnableOneClick] = useState(false);

  const toggleEnableOneClick = () => setEnableOneClick(!enableOneClick);

  const key = uniqueId();

  return (
    <div className="payment-option-collapse">
      <div>
        <FormattedMessage
          id="wallet-payment.instruction"
          defaultMessage="Click the button to be redirected to {paymentMethod} and complete your payment securely"
          values={{ paymentMethod: method.name }}
        />
        {!!transactionFee &&
          <p>
            <FormattedMessage
              id="wallet-payment.fee-details"
              defaultMessage="You will be charged a {transactionFeePercent} when you pay with {paymentMethod}. {transactionFeeValue} will be added to the total of your order"
              values={{
                paymentMethod: method.name,
                transactionFeeValue: <SpecialFormattedNumber
                  value={transactionFee.amountPounds}
                  style="currency"
                  currency={currency}
                />,
                transactionFeePercent: <FormattedNumber style="percent" value={transactionFee.percent} />,
              }}
            />
          </p>
        }
      </div>
      {(oneClickOption || isSubscription) && !isNewSavedMethod &&
        <div className="remember-tick-container mt-2">
          <label htmlFor={`rememeber-${key}`}>
            <input disabled={isSubscription} type="checkbox" id={`rememeber-${key}`} name={`rememeber-${key}`} defaultChecked={isSubscription ? true : enableOneClick} onChange={() => toggleEnableOneClick()} />
            <FormattedMessage
              id="wallet-payment.remember-tickbox"
              defaultMessage="Save my {paymentMethod} details"
              values={{ paymentMethod: method.name }}
            />
          </label>
        </div>
      }
      <div className="complete-button-container">
        <PaymentButton
          type={method.type}
          name={method.name}
          enableOneClick={enableOneClick}
        />
      </div>
    </div>
  );
}

WalletPayment.propTypes = {
  method: PropTypes.shape({}).isRequired,
};
